<template>
  <article class="panel is-info" :class="className">
    <div class="panel-heading">
      {{ content.Title }}
    </div>
    <div class="panel-block content" v-if="!ismenu && content.Subtitle" v-html="content.Subtitle"></div>
    <div class="panel-block content" v-if="!content.Subtitle">
      <slot></slot>
    </div>
    <div class="panel-block" v-if="hasCallToAction">
      <router-link class="button is-fullwidth is-primary is-medium" tag="a" :to="{path: content.CallToAction.Link}">
        <span><strong>{{ content.CallToAction.Text }}</strong></span>
        <span class="icon">
          <font-awesome-icon :icon="icons.chevronRight" />
        </span>
      </router-link>
    </div>
    <div class="panel-block menu" v-if="ismenu">
      <ul class="menu-list">
        <li v-for="(item_t, idx_t) in content.Subtitle" :key="idx_t">
          <strong><a :href="'#' + item_t.id" @click.prevent="scrollTo(item_t.id)">{{ item_t.title }}</a></strong>
          <ul v-if="item_t.sub.length > 0">
            <li v-for="(item_s, idx_s) in item_t.sub" :key="idx_s">
              <a :href="'#' + item_s.id" @click.prevent="scrollTo(item_s.id)">
                <font-awesome-icon :icon="icons.chevronRight" class="has-text-primary" />
                {{ item_s.title }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </article>
</template>

<script>

import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { elementScrollTo } from '@/mixins/elementScrollTo.js'

export default {
  name: 'contentBlock',
  data () {
    return {
      icons: {
        chevronRight: faChevronRight
      }
    }
  },
  props: {
    content: Object,
    ismenu: Boolean,
    className: String
  },
  components: {

  },
  mixins: [elementScrollTo],
  computed: {
    hasCallToAction () {
      return !!(this.content.CallToAction && Object.keys(this.content.CallToAction).length > 0 && this.content.CallToAction.Link !== '' && this.content.CallToAction.Text !== '')
    },
    language () {
      return this.$store.state.language
    }
  },
  methods: {
    scrollTo (id) {
      var self = this
      var element = document.getElementById(id)
      self.elementScrollTo(element)
      history.replaceState(null, null, '#' + id)
    }
  }
}
</script>

<style lang="scss" scoped>

.panel{

  .panel-heading{
    @include setDecoration;
  }

  .panel-block{
    padding: 20px 25px 30px;
    margin: 0;
    &.content{
      display: block;
    }
    &.menu{

      .menu-list{
        width: 100%;
        >li{
          padding: 8px 0;
          + li{
            border-top: 2px solid $grey-lighter;
          }
          >strong{
            font-size: 15px;
          }
          svg{
            vertical-align: middle;
            font-size: 9px;
            text-decoration: none !important;
            margin-right: 5px;
          }
          ul{
            margin: 0;
            border-left: none;
            padding-left: 0;
          }
          a{
            padding: 0.5em 0em;
            &:hover{
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>
